<div class="jumbotron">
    <h1 class="text-center">Daily Huddle Report</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="reports-content">
    <ngb-tabset
        activeId="w-tab-report-0"
        #tabSet="ngbTabset"
    >
        <ngb-tab id="w-tab-report-0">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="chart-box-outline"
                ></cmps-icon>
                Select Parameters
            </ng-template>
            <ng-template ngbTabContent>
                <div class="p-3">
                    <div
                        cmpsTdDailyHuddleSelectionReport
                        [params]="selectedParams"
                        [metrics]="availableMetrics"
                        [roles]="roles"
                        [rawDates]="rawDates"
                        (generated)="onGeneratedReport($event)"
                        (changed)="onChanged()"
                    ></div>
                </div>
            </ng-template>
        </ngb-tab>
        <ngb-tab id="w-tab-report-1">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="file-document"
                ></cmps-icon>
                Daily Huddle
            </ng-template>
            <ng-template ngbTabContent>
                <div
                    class="p-3"
                    *ngIf="pendingData"
                >
                    <cmps-wait-status></cmps-wait-status>
                    <h2 class="text-center">Report is being generated</h2>
                </div>
                <div
                    class="p-3"
                    *ngIf="!pendingData && noData"
                >
                    <h3 class="text-center">
                        There is no data generated for this report
                    </h3>
                </div>
                <div
                    class="p-3"
                    *ngIf="!pendingData && !noData"
                >
                    <div>
                        <button
                            class="btn-mini"
                            ngbTooltip="Refresh"
                            (click)="getDailyHuddleReportResult()"
                        >
                            <cmps-icon svgIcon="refresh"></cmps-icon>
                        </button>
                        <button
                            ngbTooltip="Export"
                            (click)="onExportClick()"
                            class="btn-mini"
                        >
                            <cmps-icon svgIcon="download"></cmps-icon>
                        </button>
                    </div>
                    Name: <b class="f-s-75-2">{{ selectedUser?.userName }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Role:
                    <b class="f-s-75-2">{{ selectedRole?.roleName }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Date: <b class="f-s-75-2">{{ params?.date }}</b>
                    <span class="soft-pipe">|</span>
                    Generated On:
                    <b class="f-s-75-2">{{ params?.dateRequest }}</b>

                    <div class="table-container mt-3 cmps-reports-table">
                        <table
                            #table
                            class="table"
                        >
                            <tr class="head">
                                <th
                                    class="title odd text-center vertical-center"
                                >
                                    Name
                                </th>
                                <th
                                    class="title even"
                                    [attr.colspan]="metrics.length"
                                    [style.min-width]="
                                        metrics.length * 150 + 'px'
                                    "
                                >
                                    Week to Date
                                    <span
                                        *ngIf="dataRanges[0]"
                                        class="sub"
                                    >
                                        ({{
                                            dataRanges[0].startDate
                                                | cmpsDate: 'MMM d'
                                        }}
                                        -
                                        {{
                                            dataRanges[0].endDate
                                                | cmpsDate: 'MMM d'
                                        }})
                                    </span>
                                </th>
                                <th
                                    class="title odd"
                                    [attr.colspan]="metrics.length"
                                    [style.min-width]="
                                        metrics.length * 150 + 'px'
                                    "
                                >
                                    Month to Date
                                    <span
                                        *ngIf="dataRanges[1]"
                                        class="sub"
                                    >
                                        ({{
                                            dataRanges[1].startDate
                                                | cmpsDate: 'MMM d'
                                        }}
                                        -
                                        {{
                                            dataRanges[1].endDate
                                                | cmpsDate: 'MMM d'
                                        }})
                                    </span>
                                </th>
                                <th
                                    class="title even"
                                    [attr.colspan]="metrics.length"
                                    [style.min-width]="
                                        metrics.length * 150 + 'px'
                                    "
                                >
                                    Quarter to Date
                                    <span
                                        *ngIf="dataRanges[2]"
                                        class="sub"
                                    >
                                        ({{
                                            dataRanges[2].startDate
                                                | cmpsDate: 'MMM d'
                                        }}
                                        -
                                        {{
                                            dataRanges[2].endDate
                                                | cmpsDate: 'MMM d'
                                        }})
                                    </span>
                                </th>
                                <th
                                    class="title odd"
                                    [attr.colspan]="metrics.length"
                                    [style.min-width]="
                                        metrics.length * 150 + 'px'
                                    "
                                >
                                    Year to Date
                                    <span
                                        *ngIf="dataRanges[3]"
                                        class="sub"
                                    >
                                        ({{
                                            dataRanges[3].startDate
                                                | cmpsDate: 'MMM d yyyy'
                                        }}
                                        -
                                        {{
                                            dataRanges[3].endDate
                                                | cmpsDate: 'MMM d yyyy'
                                        }})
                                    </span>
                                </th>
                            </tr>
                            <tr>
                                <th>&nbsp;</th>
                                <ng-container
                                    *ngTemplateOutlet="
                                        calculatedColumnsSubtitles
                                    "
                                ></ng-container>
                            </tr>
                            <tr *ngFor="let row of result">
                                <td>
                                    <cmps-icon
                                        class="cmps-cdk-fill-grey-300"
                                        svgIcon="account-circle"
                                    ></cmps-icon>
                                    {{ row.userName }}
                                </td>
                                <td
                                    class="text-center"
                                    *ngFor="let metric of row.metrics"
                                >
                                    {{ metric?.actual | number: '1.2-2' }}
                                </td>
                            </tr>
                        </table>
                        <ng-template #calculatedColumnsSubtitles>
                            <ng-template
                                ngFor
                                let-meta
                                [ngForOf]="[1, 2, 3, 4]"
                            >
                                <ng-template
                                    ngFor
                                    let-metric
                                    [ngForOf]="metrics"
                                >
                                    <th class="subtitle">{{ metric?.name }}</th>
                                </ng-template>
                            </ng-template>
                        </ng-template>
                    </div>
                </div>
            </ng-template>
        </ngb-tab>
    </ngb-tabset>
</div>
